import { trackAnalyticsEvent } from '@eb/site-analytics';

export const GA_BRANCH_IO_CATEGORY = 'BranchEvent';

// BranchIOEvent
export const trackBranchIOEvent = ({ eventName, journeyName }) => {
    trackAnalyticsEvent({
        category: GA_BRANCH_IO_CATEGORY,
        action: eventName,
        label: journeyName,
    });
};
